import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormControl, Select } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';

import {
  SECTION_UP_TO_FOUR,
  SECTION_UP_TO_FIVE,
  SECTION_UP_TO_SIX,
  SECTION_UP_TO_SEVEN,
  SECTION_UP_TO_EIGHT,
  SECTION_UP_TO_NINE,
  SECTION_MIRROR,
  SECTION_TEN,
} from '@/modules/Simulators';

import useStyles from '../style';

export const options = [
  {
    value: SECTION_UP_TO_FOUR,
    label: 'SECTION_UP_TO_FOUR',
  },
  {
    value: SECTION_UP_TO_FIVE,
    label: 'SECTION_UP_TO_FIVE',
  },
  {
    value: SECTION_UP_TO_SIX,
    label: 'SECTION_UP_TO_SIX',
  },
  {
    value: SECTION_UP_TO_SEVEN,
    label: 'SECTION_UP_TO_SEVEN',
  },
  {
    value: SECTION_UP_TO_EIGHT,
    label: 'SECTION_UP_TO_EIGHT',
  },
  {
    value: SECTION_UP_TO_NINE,
    label: 'SECTION_UP_TO_NINE',
  },
  {
    value: SECTION_MIRROR,
    label: 'SECTION_MIRROR',
  },
  {
    value: SECTION_TEN,
    label: 'SECTION_TEN',
  },
];

export default function SectionField({ params, changeParams }) {
  const classes = useStyles();

  return (
    <Grid item xs={12} classes={{ root: classes.grid }}>
      <FormControl classes={{ root: classes.formControl }}>
        <p className={classes.mainSettingsHeader}>
          <FormattedMessage id="section" defaultMessage="" />
        </p>
      </FormControl>
      <Select
        MenuProps={{
          style: { zIndex: 2000 },
        }}
        className="settings-input"
        disableUnderline
        inputProps={{ name: 'section' }}
        value={params.section}
        onChange={event => changeParams(event.target.value, event.target.name)}
        IconComponent={ExpandMoreIcon}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <FormattedMessage id={option.label} defaultMessage="" />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}

SectionField.propTypes = {
  changeParams: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};
